import AppButton from "../../../components/AppButton";
import config from "../../../utils/config";
import Cross from "../../../assets/logo/cross.svg";
import AppDialog from "../../../components/AppDialog";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
export default function KycBlocked({
  showKytBlocked,
  setShowKytBlocked,
  handleVerification,
}) {
  const { t } = useTranslation();
  return (
    <AppDialog show={showKytBlocked} onChangeShow={setShowKytBlocked} showClose={false}>
      <Box
        sx={{
          display: "flex",
          flexFlow: "row",
          justifyContent: "center",
          padding: "40% 0 10% 0",
        }}
      >
        <Cross style={{ width: 84, height: 84 }} />
      </Box>
      <Box paddingLeft={3} paddingRight={3}>
        <Typography
          color={"#F8FAFF"}
          fontWeight={700}
          fontSize={16}
          textAlign="center"
        >
          {t("kyc.failedTitle")}
        </Typography>
        <Typography
          variant="subtitle1"
          color={"#F8FAFF"}
          fontSize={14}
          fontWeight={400}
          textAlign="center"
        >
          {t("kyc.failed")}
        </Typography>
        <AppButton
          title={t("contact")}
          href={config.ZENDESK_SUPPORT}
          target="_blank"
        />
        <Button
          variant="text"
          sx={{ marginTop: 2, width: "100%" }}
          onClick={handleVerification}
        >
          {t("tryAgain")}
        </Button>
      </Box>
    </AppDialog>
  );
}
